import React from 'react';
import StrippedClickReveal from '../../body/StrippedClickRevealRoutines.js';

const data = {
  static:
    '<h1>What Is the Meaning Behind Routines</h1><p>Pick a value that is important to you, and you want your child to learn ... see some examples of routines that help teach your child that value:</p>',
  activityBadge: 'badge11',
  voiceOver:
    '<p>Think about the routines and traditions you have in your family. Consider these questions: <ul><li>Why are these routines or traditions important to you? </li><li>How well do you stick to these routines and traditions?  For example, do they only happen some of the time or do they happen regularly? </li><li>If your family has no routines or traditions, why do you think this is?</li></ul></p>',
};

const FamilyRoutinesActivity = () => {
  return (
    <div className='text-left space-y-6'>
      <div className='mb-4 '>
        <h1 className='text-2xl font-bold mb-2 text-center '>
          What Is the Meaning Behind Routines?
        </h1>
        <p className='mb-4 p-4'>
          Select a value that may be important to a parent and that they would
          want their child to learn – you will see examples of routines that can
          help parents teach their child that value.
        </p>
      </div>
      <div className='mb-6'>
        <StrippedClickReveal />
      </div>
    </div>
  );
};

export default FamilyRoutinesActivity;
